export default __webpack_public_path__ + "static/media/img-stack-for-coins-mobile.fe725072.png";